import { Divider, Stack } from '@ekhodealer/ekho-common/rev';

import { BuyerDetailsSection } from './BuyerDetailsSection';
import { FulfillmentDetailsSection } from './FulfillmentDetailsSection';
import { OverviewSection } from './OverviewSection';
import { PartsGarmentsAndAccessoriesSection } from './PartsGarmentsAndAccessoriesSection';
import { ReferenceSection } from './ReferenceSection';
import { RegistrationDetailsSection } from './RegistrationDetailsSection';
import { RiskReviewSection } from './RiskReviewSection';
import { VehicleDetailsSection } from './VehicleDetailsSection';

export const DetailsTabContent = () => {
	return (
		<Stack>
			<ReferenceSection />
			<Divider />
			<OverviewSection />
			<Divider />
			<VehicleDetailsSection />
			<Divider />
			<PartsGarmentsAndAccessoriesSection />
			<Divider />
			<FulfillmentDetailsSection />
			<Divider />
			<RegistrationDetailsSection />
			<Divider />
			<BuyerDetailsSection />
			<Divider />
			<RiskReviewSection />
		</Stack>
	);
};
